import { push } from "connected-react-router";
import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import contractService from "../services/contractService";
import { toggleLoader } from "./loaderActions";
import { loadProjectSuccess } from "./projectActions";
import { loadSupportTicketSuccess } from "./supportTicketActions";
import { loadCallSuccess } from "./callActions";

export function loadContractSuccess(contracts) {
  return {
    type: types.LOAD_CONTRACT_SUCCESS,
    contracts
  };
}

export function loadContractByCustomerSuccess(contractsByCustomer) {
  return {
    type: types.LOAD_CONTRACT_BY_CUSTOMER_SUCCESS,
    contractsByCustomer
  };
}

export function getContractSuccess(contract) {
  return {
    type: types.GET_CONTRACT_SUCCESS,
    contract
  };
}

export function loadingContract(status = true) {
  return {
    type: types.LOADING_CONTRACT,
    loadingContract: status
  };
}

export function savingContract(status = true) {
  return {
    type: types.SAVING_CONTRACT,
    savingContract: status
  };
}

export function createContractSuccess(contract) {
  return {
    type: types.CREATE_CONTRACT_SUCCESS,
    contract
  };
}

export function updateContractSuccess(contract) {
  return {
    type: types.UPDATE_CONTRACT_SUCCESS,
    contract
  };
}

export function deleteContractSuccess(contractId) {
  return {
    type: types.DELETE_CONTRACT_SUCCESS,
    contractId
  };
}

export function clearContract() {
  return { type: types.RESET_CONTRACT_SUCCESS };
}

export function clearContracts() {
  return (dispatch) => dispatch(loadContractSuccess([]));
}

export function loadITMSContractsSuccess(contracts) {
  return {
    type: types.LOAD_ITMS_CONTRACTS_SUCCESS,
    contracts
  };
}

export function clearITMSContracts() {
  return (dispatch) => dispatch(loadITMSContractsSuccess([]));
}

export function requestContractId(contractId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_CONTRACT_ID,
      contractToDelete: contractId
    });
    dispatch(showModalSuccess("contractDeleteModal"));
  };
}

export function requestNoteId(noteId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_CONTRACT_NOTE_ID,
      contractNoteToDelete: noteId
    });
    dispatch(showModalSuccess("noteDeleteModal"));
  };
}

export function requestPOId(poId, DELETE = false) {
  return (dispatch) => {
    if (DELETE) {
      dispatch({
        type: types.REQUEST_CONTRACT_PO_ID,
        contractPOToDelete: poId
      });
      dispatch(showModalSuccess("purchaseOrderDeleteModal"));
    } else {
      dispatch({
        type: types.REQUEST_CONTRACT_PO_ID,
        contractPOToDelete: poId
      });
      dispatch(showModalSuccess("purchaseOrderConfirmModal"));
    }
  };
}

export function loadContracts(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return contractService
      .loadContracts(payload)
      .then(async (data) => {
        await dispatch(loadContractSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function loadITMSContracts(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return contractService
      .loadITMSContracts(payload)
      .then(async (data) => {
        await dispatch(loadITMSContractsSuccess(data.contracts));
        await dispatch(loadProjectSuccess(data.projects));
        await dispatch(loadSupportTicketSuccess(data.tickets));
        await dispatch(loadCallSuccess(data.calls));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function loadITHealthScoreContract(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return contractService
      .loadITHealthScoreContract(payload)
      .then(async (data) => {
        dispatch(getContractSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function loadContractsByCustomerId(id) {
  return (dispatch) =>
    contractService
      .loadContractsByCustomerId(id)
      .then((data) => dispatch(loadContractByCustomerSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getContract(id, showCONTRACTDetails = false) {
  return (dispatch) => {
    dispatch(loadingContract());
    return contractService
      .getContract(id)
      .then((contract) => {
        dispatch(getContractSuccess(contract));
        dispatch(loadingContract(false));
        if (showCONTRACTDetails) {
          dispatch(showModalSuccess("contractDetailsModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function createContract(contract, redirect = true) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .createContract(contract)
      .then((createdContract) => {
        dispatch(createContractSuccess(createdContract));
        dispatch(savingContract(false));
        dispatch(hideModalSuccess("contractDetailsModal"));
        dispatch(showAlertSuccess("Contract created successfully", "success"));
        if (redirect) {
          dispatch(showModalSuccess("redirectToProjectModal", createdContract));
        }
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateContract(contract, redirect = true) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .updateContract(contract)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(hideModalSuccess("contractDetailsModal"));
        dispatch(showAlertSuccess("Contract updated successfully", "success"));
        if (redirect) {
          dispatch(push("/app/contracts"));
        }
      })
      .catch(({ response }) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(`${response.data.errors.message}`, "error"));
      });
  };
}

export function updateITHealthScore(contract) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .updateITHealthScore(contract)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(
          showAlertSuccess("IT Health Score updated successfully", "success")
        );
      })
      .catch(({ response }) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(`${response.data.errors.message}`, "error"));
      });
  };
}

export function deleteContract(id) {
  return (dispatch) =>
    contractService
      .deleteContract(id)
      .then(() => {
        dispatch(deleteContractSuccess(id));
        dispatch(showAlertSuccess("Contract deleted successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

// ATTACHMENTS
export function addVersion(contract, files) {
  return (dispatch) => {
    dispatch(savingContract());
    if (files.length === 1) {
      return contractService
        .uploadFile(contract, files[0])
        .then((updatedContract) => {
          dispatch(updateContractSuccess(updatedContract));
          dispatch(savingContract(false));
          dispatch(showAlertSuccess("Version added successfully", "success"));
          dispatch(push(`/app/contracts/${contract.id}`));
        })
        .catch((error) => {
          dispatch(savingContract(false));
          dispatch(showAlertSuccess(error.description, "error"));
        });
    }
    dispatch(savingContract(false));
    dispatch(showAlertSuccess("Upload 1 File at a Time", "error"));
  };
}

export function downloadVersion(contract, version) {
  return (dispatch) =>
    contractService
      .downloadVersion(contract, version)
      .then(() => {
        dispatch(
          showAlertSuccess("Version downloaded successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function updateVersion(contract, version) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .updateLocation(contract, version)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(showAlertSuccess("Version updated successfully", "success"));
        dispatch(push("/app/contracts"));
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteVersion(contract, version) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .deleteVersion(contract, version)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(showAlertSuccess("Version deleted successfully", "success"));
        dispatch(push("/app/contracts"));
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

// NOTES
export function createNote(contract, note) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .createNote(contract, note)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(hideModalSuccess("contractDetailsModal"));
        dispatch(showAlertSuccess("Note added successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateNote(contract, note) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .updateNote(contract, note)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(hideModalSuccess("contractDetailsModal"));
        dispatch(showAlertSuccess("Note updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteNote(contract, note) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .deleteNote(contract, note)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(showAlertSuccess("Note deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

// -------------- Purchase Order ----------------------------------

export function createPurchaseOrder(contract, purchaseOrder) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .createPurchaseOrder(contract, purchaseOrder)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(hideModalSuccess("contractDetailsModal"));
        dispatch(
          showAlertSuccess("Purchase Order added successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updatePurchaseOrder(contract, purchaseOrder) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .updatePurchaseOrder(contract, purchaseOrder)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(
          showAlertSuccess("Purchase Order updated successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deletePurchaseOrder(contract, purchaseOrder) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .deletePurchaseOrder(contract, purchaseOrder)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(
          showAlertSuccess("Purchase Order deleted successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateMetrics(contract, line, data) {
  return (dispatch) => {
    dispatch(savingContract());
    return contractService
      .updateLine(contract, line, data)
      .then((updatedContract) => {
        dispatch(updateContractSuccess(updatedContract));
        dispatch(savingContract(false));
        dispatch(showAlertSuccess("Metrics updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingContract(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function loadActiveContracts(payload) {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return contractService
      .loadActiveContracts(payload)
      .then(async (data) => {
        await dispatch(loadContractSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}
